export default [
  {
    path: "/users/:userId/profile",
    props: true,
    component: () => import("@/views/user/UserView.vue"),
    meta: {
      useNewContainer: true,
    },
    children: [
      {
        path: "",
        props: true,
        component: () => import("@/views/user/UserView.vue"),
        meta: {
          component: "UserProfileUpdatePersonalInfo",
          useNewContainer: true,
        },
      },
      {
        path: "payment-methods",
        props: true,
        component: () => import("@/views/user/UserView.vue"),
        meta: {
          component: "UserProfileUpdateMemberPaymentMethods",
          useNewContainer: true,
        },
      },
      {
        path: "change-password",
        props: true,
        component: () => import("@/views/user/UserView.vue"),
        meta: {
          component: "UserProfileUpdateChangePassword",
          useNewContainer: true,
        },
      },
      {
        path: "communication-settings",
        props: true,
        component: () => import("@/views/user/UserView.vue"),
        meta: {
          component: "UserProfileUpdateCommunicationSettings",
          useNewContainer: true,
        },
      },
    ],
  },
  {
    path: "/users/:userId/confirm/email",
    props: true,
    component: () => import("@/views/user/UserConfirmEmailAddressView.vue"),
    meta: {
      authentication: { required: false },
      hideNav: true,
    },
  },
  {
    path: "/users/:userId/businesses/:businessId/confirm/email",
    props: true,
    component: () => import("@/views/user/BusinessMemberConfirmEmailAddressView.vue"),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
    },
  },
  {
    path: "/users/:userId/plans",
    props: true,
    component: () => import("@/views/user/UserPlansView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/users/:userId/documents",
    props: true,
    component: () => import("@/views/user/UserDocuments.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
    },
  },
  {
    path: "/users/:userId/businesses/:businessId/plans/:userBusinessPlanId/",
    props: true,
    component: () => import("@/views/user/UserPlanView.vue"),
    children: [
      {
        path: "details",
        props: true,
        component: () => import("@/views/user/UserPlanDetails.vue"),

        meta: {
          component: "UserPlanDetails",
          authentication: { required: true },
          useNewContainer: true,
        },
      },
      {
        path: "charges",
        props: true,
        component: () => import("@/views/user/UserPlanCharges.vue"),

        meta: {
          component: "UserPlanCharges",
          authentication: { required: true },
          useNewContainer: true,
        },
      },
      {
        path: "credits",
        props: true,
        component: () => import("@/views/user/UserPlanCredits.vue"),

        meta: {
          component: "UserPlanCredits",
          authentication: { required: true },
          useNewContainer: true,
        },
      },
    ],
    meta: {
      authentication: { required: true },
    },
  },
  {
    path: "/users/:userId/plans/:userBusinessPlanId/activate",
    props: true,
    component: () => import("@/views/user/UserPlanActivationView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
    },
  },
  {
    path: "/user/support",
    component: () => import("@/views/user/support/UserSupportView.vue"),
    meta: {
      useNewContainer: true,
      authentication: { required: true },
    },
  },
];
